// Returns true if there are no duplicate values of the fields listed
// in the `fields` array across the objects in the `items` array, false
// otherwise.
// Note that if a value of a field in an item is not set, it will be
// excluded from comparison.
const containUniqueFields = (items, fields) => {
  const map = new Map();
  const itemsHaveDuplicateFields = items.some(item => fields.some(field => {
    if (!map.has(field)) {
      map.set(field, new Map());
    }
    if (!item[field]) {
      // We exclude empty values from comparison
      return false;
    }

    // Duplicate found!
    if (map.get(field).has(item[field])) return true;
    map.get(field).set(item[field], true);
    return false;
  }));
  return !itemsHaveDuplicateFields;
};
export default containUniqueFields;